import Vue from 'vue'
import Router from 'vue-router'
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)


export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  },
  routes: [
    {
      path: '',
      name: 'SideMenu',
      component: resolve => require(['../layouts/SideMenu.vue'], resolve),
      redirect: '/workBench/workbench',
      children: [
        {
          path: 'workBench',
          name: 'workBench',
          meta: {hidden: false, show: true, title: "工作台", icon: 'dashboard'},
          component: resolve => require(['../layouts/none.vue'], resolve),
          children: [
            {
              path: 'workbench',
              name: '工作台',
              meta: {hidden: false, show: true, title: "工作台"},
              component: resolve => require(['../views/workBench/workBench.vue'], resolve),
            },
            {
              path: 'staffAssetList',
              name:'员工管理的资产',
              meta: {hidden: false, show: true, title: "员工管理的资产"},
              component: resolve => require(['../views/workBench/staffAssetList.vue'], resolve),
              
            },
            {
              path: 'threeYearRentPlan',
              name: '三年租金计划',
              meta: {hidden: false, show: true, title: "三年租金计划"},
              component: resolve => require(['../views/workBench/threeYearRentPlan.vue'], resolve),
            },
            {
              path: 'payExpenseManagement',
              name: '支出费用管理',
              meta: {hidden: false, show: true, title: "支出费用管理"},
              component: resolve => require(['../views/workBench/payExpenseManagement.vue'], resolve),
            },
          ],
        },
        {
          path: 'organizationalManagement',
          name: 'organizationalManagement',
          meta: {hidden: false, show: true, title: "组织结构管理", icon: 'form'},
          component: resolve => require(['../layouts/none.vue'], resolve),
          children: [
            {
              path: 'organizational',
              name: '组织架构层级',
              meta: {hidden: false, show: true, title: "组织架构层级"},
              component: resolve => require(['../views/organizationalManagement/organizational.vue'], resolve),
            },
            {
              path: 'roles',
              name: '角色管理',
              meta: {hidden: false, show: true, title: "角色管理"},
              component: resolve => require(['../views/organizationalManagement/roles.vue'], resolve),
            },
            {
              path: 'roleDetail',
              name: '角色管理-新增/编辑角色',
              meta: {hidden: true, show: true, title: "角色管理-新增/编辑角色", activeSlide: '/organizationalManagement/roles'},
              component: resolve => require(['../views/organizationalManagement/roleDetail.vue'], resolve),
            },
            {
              path: 'personnels',
              name: '人员管理',
              meta: {hidden: false, show: true, title: "人员管理"},
              component: resolve => require(['../views/organizationalManagement/personnels.vue'], resolve),
            },
            {
              path: 'personnelDetail',
              name: '人员管理-新增/编辑人员',
              meta: {
                hidden: true,
                show: true,
                title: "人员管理-新增/编辑人员",
                activeSlide: '/organizationalManagement/personnels'
              },
              component: resolve => require(['../views/organizationalManagement/personnelDetail.vue'], resolve),
            },
          ],
        },
        {
          path: 'assetManagement',
          name: 'assetManagement',
          meta: {hidden: false, show: true, title: "资产管理", icon: 'table'},
          component: resolve => require(['../layouts/none.vue'], resolve),
          children: [
            {
              path: 'assetList',
              name: '资产列表',
              meta: {hidden: false, show: true, title: "资产列表"},
              component: resolve => require(['../views/assetManagement/assetList.vue'], resolve),
            },
            {
              path: 'assetOperation',
              name: '新增/编辑资产',
              meta: {hidden: true, show: true, title: "新增/编辑资产", activeSlide: '/assetManagement/assetList'},
              component: resolve => require(['../views/assetManagement/assetOperation.vue'], resolve),
            },
            {
              path: 'assetDetail',
              name: '资产详情',
              meta: {hidden: true, show: true, title: "资产详情", activeSlide: '/assetManagement/assetList'},
              component: resolve => require(['../views/assetManagement/assetDetail.vue'], resolve),
            },
            {
              path: 'assetReport',
              name: '资产报表统计',
              meta: {hidden: false, show: true, title: "资产报表统计"},
              component: resolve => require(['../views/assetManagement/assetReport.vue'], resolve),
            },
            {
              path: 'contractOperation',
              name: '合同编辑/新增',
              meta: {hidden: true, show: true, title: "合同编辑/新增", activeSlide: '/assetManagement/assetList'},
              component: resolve => require(['../views/assetManagement/contractOperation.vue'], resolve),
            },
            {
              path: 'generateAuctionNotice',
              name: '一键转至360pai进行租赁权拍卖',
              meta: {hidden: true, show: true, title: "一键转至360pai进行租赁权拍卖", activeSlide: '/assetManagement/assetList'},
              component: resolve => require(['../views/assetManagement/auction/generateAuctionNotice/generateAuctionNotice.vue'], resolve),
            },
            {
              path: 'auctionNoticePreview',
              name: '一按键转拍卖-预览招租公告',
              meta: {hidden: true, show: true, title: "一键转至360pai进行租赁权拍卖", activeSlide: '/assetManagement/assetList'},
              component: resolve => require(['../views/assetManagement/auction/auctionNoticePreview/auctionNoticePreview.vue'], resolve),
            },
            {
              path: 'noticePreview',
              name: '招租公告',
              meta: {hidden: true, show: true, title: "招租公告", activeSlide: '/assetManagement/assetList'},
              component: resolve => require(['../views/assetManagement/components/noticePreview.vue'], resolve),
            },
            {
              path: 'auctionInfo',
              name: '一按键转拍卖-填写拍卖信息',
              meta: {hidden: true, show: true, title: "一键转至360pai进行租赁权拍卖", activeSlide: '/assetManagement/assetList'},
              component: resolve => require(['../views/assetManagement/auction/auctionInfo/auctionInfo.vue'], resolve),
            },
            {
              path: 'auctionSuccess',
              name: '一按键转拍卖-上传成功',
              meta: {hidden: true, show: true, title: "一键转至360pai进行租赁权拍卖", activeSlide: '/assetManagement/assetList'},
              component: resolve => require(['../views/assetManagement/auction/auctionSuccess.vue'], resolve),
            },
            
            {
              path: 'generateMerchantNotice',
              name: '一键转至360pai进行租赁权招商',
              meta: {hidden: true, show: true, title: "一键转至360pai进行租赁权招商", activeSlide: '/assetManagement/assetList'},
              component: resolve => require(['../views/assetManagement/merchant/generateMerchantNotice/generateMerchantNotice.vue'], resolve),
            },
            {
              path: 'merchantNoticePreview',
              name: '一按键转招商-预览招租公告',
              meta: {hidden: true, show: true, title: "一键转至360pai进行租赁权招商", activeSlide: '/assetManagement/assetList'},
              component: resolve => require(['../views/assetManagement/merchant/merchantNoticePreview/merchantNoticePreview.vue'], resolve),
            },
            {
              path: 'merchantInfo',
              name: '一按键转招商-填写拍卖信息',
              meta: {hidden: true, show: true, title: "一键转至360pai进行租赁权招商", activeSlide: '/assetManagement/assetList'},
              component: resolve => require(['../views/assetManagement/merchant/merchantInfo/merchantInfo.vue'], resolve),
            },
            {
              path: 'merchantSuccess',
              name: '一按键转招商-上传成功',
              meta: {hidden: true, show: true, title: "一键转至360pai进行租赁权招商", activeSlide: '/assetManagement/assetList'},
              component: resolve => require(['../views/assetManagement/merchant/merchantSuccess.vue'], resolve),
            },
          ],
        },
        {
          path: 'tenantManagement',
          name: 'tenantManagement',
          meta: {hidden: false, show: true, title: "租客管理", icon: 'table'},
          component: resolve => require(['../layouts/none.vue'], resolve),
          children: [
            {
              path: 'tenantList',
              name: '租客管理',
              meta: {hidden: false, show: true, title: "租客管理"},
              component: resolve => require(['../views/tenantManagement/tenantList.vue'], resolve),
            },
            {
              path: 'tenantDetail',
              name: '租客详情',
              meta: {hidden: true, show: true, title: "租客详情", activeSlide: '/tenantManagement/tenantList'},
              component: resolve => require(['../views/tenantManagement/tenantDetail.vue'], resolve),
            },
          ],
        },
        {
          path: 'contractManagement',
          name: 'contractManagement',
          meta: {hidden: false, show: true, title: "合同管理", icon: 'profile'},
          component: resolve => require(['../layouts/none.vue'], resolve),
          children: [
            {
              path: 'contractList',
              name: '合同管理',
              meta: {hidden: false, show: true, title: "合同管理"},
              component: resolve => require(['../views/contractManagement/contractList.vue'], resolve),
            },
            {
              path: 'contractDeadlineList',
              name: '合同管理-到期合同',
              meta: {hidden: false, show: true, title: "合同管理-到期合同"},
              component: resolve => require(['../views/contractManagement/expiredContract.vue'], resolve),
            },
            {
              path: 'contractRentArrearsList',
              name: '合同管理-欠租合同',
              meta: {hidden: false, show: true, title: "合同管理-欠租合同"},
              component: resolve => require(['../views/contractManagement/arrearsContract.vue'], resolve),
            },
            {
              path: 'contractDetail',
              name: '合同详情',
              meta: {hidden: true, show: true, title: "合同详情", activeSlide: '/contractManagement/contractList'},
              component: resolve => require(['../views/contractManagement/contractDetail.vue'], resolve),
            },
          ],
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['../views/Login.vue'], resolve),
    },
    {
      path: '/forget',
      name: 'forget',
      component: resolve => require(['../views/forget.vue'], resolve),
    },
    {
      path: '/premiumAnalysis',
      meta: {hidden: false, show: true,},
      name: '成交溢价分析',
      component: resolve => require(['../views/bigData/premiumAnalysis/premium.vue'], resolve),
    },
    {
      path: '/3dmap',
      name: '3d资产地图',
      meta: {hidden: false, show: true,},
      component: resolve => require(['../views/bigData/3d/assetMap.vue'], resolve),
    },
    {
      path: '/bigData',
      name: '大数据中心首页',
      meta: {hidden: false, show: true,},
      component: resolve => require(['../views/bigData/index/index.vue'], resolve),
    },
    {
      path: '/industryStructure',
      name: '行业结构',
      meta: {hidden: false, show: true,},
      component: resolve => require(['../views/bigData/industryStructure/industryStructure.vue'], resolve),
    },
    {
      path: '/assetLeasing',
      name: '管理资产出租情况',
      meta: {hidden: false, show: true,},
      component: resolve => require(['../views/bigData/assetLeasing/index.vue'], resolve),
    },
    {
      path: '/contractExpire',
      name: '合同到期/欠租合同',
      meta: {hidden: false, show: true,},
      component: resolve => require(['../views/bigData/contractExpire/index.vue'], resolve),
    },
    {
      path: '/messageCenter',
      name: '消息中心',
      meta: {hidden: false, show: true,},
      component: resolve => require(['../views/bigData/message/messageCenter.vue'], resolve),
    },
    {
      path: '/rent',
      name: '租金情况',
      meta: {hidden: false, show: true,},
      component: resolve => require(['../views/bigData/rent/rent.vue'], resolve),
    },
  
  ]
})
